import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
} from "react-icons/fa";
import styles from "./styles.module.scss";
import footerLog from "../../assets/home-images/footer-Logo.svg";
import { Typography } from "../../components/LoadingSpinner/ui/Typography";
import Button from "../../components/Button";
import FooterBg from "../../assets/home-images/footer-bg.png";
import api from "../../services/api";

const Footer = React.forwardRef<HTMLElement>((props, ref) => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = React.useState("");
  const subscribeOption = () => {
    if (!email) {
      alert("Please enter a valid email address.");
      return;
    }
    api
      .post("/subscription", {
        email: email,
      })
      .then((response) => {
        alert("Subscription successful:");
      })
      .catch((error) => {
        console.error("Subscription error:", error);
      });
  };
  return (
    <>
      <footer ref={ref} className={styles.footer}>
        <Container fluid className={styles.footerContainer}>
          <Row className={`align-items-center py-5 ${styles.topRow}`}>
            <Col md={6} xs={12} className={styles.logoCol}>
              <img src={footerLog} alt="" className={styles.footerLogo} />
            </Col>
            <Col md={6} xs={12} className={styles.descriptionCol}>
              <p className={styles.footerDescription}>
                Discover tranquility and rejuvenation with Retrego, where every retreat is a journey to your best self.
              </p>
            </Col>
            <Col xs={12}>
              <div className={styles.rowBorder}></div>
            </Col>
          </Row>
          <Row className={styles.linksRow}>
            <Col lg={3} md={4} sm={6} xs={12} className={styles.linkColumn}>
              <div className={styles.LinkDiv}>
                <p className={styles.LinkTitle}>Categories</p>
                <ul className={styles.LinkList}>
                  <li className={styles.LinkItem}>
                    <Link to="/about" className={styles.Link}>
                      About Us
                    </Link>
                  </li>
                  <li className={styles.LinkItem}>
                    <Link to="/category2" className={styles.Link}>
                      Careers & Culture
                    </Link>
                  </li>
                  <li className={styles.LinkItem}>
                    <Link to="/join-as-partner" className={styles.Link}>
                      Become a Partner
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={3} md={4} sm={6} xs={12} className={styles.linkColumn}>
              <div className={styles.LinkDiv}>
                <p className={styles.LinkTitle}>Company</p>
                <ul className={styles.LinkList}>
                  <li className={styles.LinkItem}>
                    <Link to="/support" className={styles.Link}>
                      Support
                    </Link>
                  </li>
                  <li className={styles.LinkItem}>
                    <Link to="/terms-conditions" className={styles.Link}>
                      Terms & Conditions
                    </Link>
                  </li>
                  <li className={styles.LinkItem}>
                    <Link to="/contact" className={styles.Link}>
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col
              lg={6}
              md={12}
              sm={12}
              xs={12}
              className={styles.newsletterColumn}
            >
              <div className={styles.LinkDiv}>
                <p className={styles.LinkTitle}>Subscribe to our newsletter</p>
               
                <div className={styles.newsletterDiv}>
                  <label>Email</label>
                  <div className={styles.inputDiv}>
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      type="text"
                      placeholder="Enter your email"
                    />
                    <Button variant="primary" onClick={subscribeOption}>
                      Subscribe
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div className={styles.footerBg}>
          <img src={FooterBg} alt="" />
        </div>
      </footer>
      <Container fluid className={styles.bottomStrip}>
        <Row className={`align-items-center ${styles.bottomRow}`}>
          <Col lg={6} md={6} sm={12} xs={12} className={styles.copyrightCol}>
            <p className="mb-0">
              Copyright @ 2023 Retrego | All Rights Reserved
            </p>
          </Col>
          <Col lg={6} md={6} sm={12} xs={12} className={styles.socialCol}>
            <div className={styles.socialLinks}>
              {/* <a href="https://facebook.com" className={styles.socialLink}>
                {FaFacebook({})}
              </a>
              <a href="https://twitter.com" className={styles.socialLink}>
                {FaTwitter({})}
              </a> */}
              <a href="https://www.instagram.com/_retrego/" className={styles.socialLink}>
                {FaInstagram({})}
              </a>
              {/* <a href="https://linkedin.com" className={styles.socialLink}>
                {FaLinkedin({})}
              </a>
              <a href="https://pinterest.com" className={styles.socialLink}>
                {FaPinterest({})}
              </a> */}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
});

Footer.displayName = 'Footer'; 

export default Footer;
